import React from 'react';
import propTypes from 'prop-types';
export const MessageIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity="1"
          d="M 23.546875 8.945312 C 23.726562 8.796875 24 8.933594 24 9.164062 L 24 18.75 C 24 19.992188 22.992188 21 21.75 21 L 2.25 21 C 1.007812 21 0 19.992188 0 18.75 L 0 9.167969 C 0 8.933594 0.265625 8.804688 0.453125 8.949219 C 1.503906 9.765625 2.898438 10.800781 7.679688 14.273438 C 8.667969 14.996094 10.335938 16.515625 12 16.503906 C 13.671875 16.519531 15.375 14.96875 16.328125 14.273438 C 21.109375 10.800781 22.496094 9.757812 23.546875 8.945312 Z M 12 15 C 13.085938 15.019531 14.652344 13.632812 15.441406 13.058594 C 21.660156 8.546875 22.132812 8.152344 23.570312 7.027344 C 23.839844 6.816406 24 6.488281 24 6.140625 L 24 5.25 C 24 4.007812 22.992188 3 21.75 3 L 2.25 3 C 1.007812 3 0 4.007812 0 5.25 L 0 6.140625 C 0 6.488281 0.160156 6.8125 0.429688 7.027344 C 1.867188 8.148438 2.339844 8.546875 8.558594 13.058594 C 9.347656 13.632812 10.914062 15.019531 12 15 Z M 12 15 "
        />
      </g>
    </svg>
  );
};
MessageIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
MessageIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
